import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {RedomatModel} from "../models/Redomat";

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/redomat`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getRedomatAll() {
    return await axios.get<Array<RedomatModel>>(API, {headers: headers})
}

export async function fetchRedomat(Id: number) {
    try {
        const response = await axios.get(`${API}/${Id}`)
        if (response.data && response.data.error === 0) {
            return response.data
        } else {
            // Handle any other type of response structure or errors returned from the server here
            throw new Error(response.data.message || 'Failed to fetch.')
        }
    } catch (error) {
        console.error('Error fetching data:', error)
        throw error // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function updateRedomat(Id: number, Data: any) {
    try {
        const response = await axios.post(`${API}/${Id}?_method=PATCH`, Data, {headers: headers})
        if (response.data.error === 0) {
            return response.data
        } else {
            // Handle any other type of response structure or errors returned from the server here
            throw new Error(response.data.message || 'Failed to fetch.')
        }
    } catch (error) {
        console.error('Error Updating data:', error)
        throw error // Re-throw the error so it can be handled by the caller if necessary
    }
}